import { render, staticRenderFns } from "./pageElementRichtext.vue?vue&type=template&id=5d86411d&"
import script from "./pageElementRichtext.vue?vue&type=script&lang=js&"
export * from "./pageElementRichtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports